// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RJiT","footer":"styles_footer__12OLb","passCodeTooltip":"styles_passCodeTooltip__1g7FZ"};